import type { Group } from '@gcv/shared';
import { OrganizationRoleResolver } from '@gcv/shared';

export default class OrganizationRoleResolverMock extends OrganizationRoleResolver {
  override getUsersGroups = (orgGroups: Group[], userId: string): Group[] => {
    return [];
  };
}
